import "./Privacy.css";
const PrivacyPage = () => {
  return (
    <>
      <div className="container Privacy-Page">
        <div className="justify-content-center align-items-center">
          <div className="font-500-44 ms-2 mb-3 mt-2 Privacytitle">
            Global Privacy Notice
          </div>
          <div className="d-block justify-content-center pt-2 ms-2">
            <p className="font-300-15">
              Fan1 LLC (together with any future affiliates,{" "}
              <span className="spanterms">“Fan1”</span>), as a{" "}
              <span className="spanterms">“data controller”</span> or a{" "}
              <span className="spanterms">“business”</span>, collects and
              processes your personal information. Fan1 is committed to being
              transparent about how it collects and uses that data and to
              meeting its data protection obligations in accordance with
              applicable data protection laws.
            </p>

            <p className="font-300-15">
              It is important that you read and understand this notice, together
              with any other privacy notice we may provide on specific occasions
              when we are collecting or processing personal information about
              you, so that you are aware of how and why we are using such
              information and what your rights are under the applicable data
              protection laws. Processing means any operation which is performed
              on personal information such as collection, recording,
              organization, structuring, storage, adaptation, or alteration,
              retrieval, consultation, use, disclosure, disclosure by
              transmission, dissemination or otherwise making available,
              alignment or combination, restriction, erasure, or destruction.
            </p>

            <p className="font-300-15">
              <span className="spanterms">Your Rights</span>
              <br />
              The General Data Protection Regulation (GDPR) and the UK GDPR
              afford residents in those jurisdictions with certain rights. Fan1
              takes privacy seriously, so we grant these rights across the
              globe. Here are your rights, regardless of where you live:
            </p>

            <p className="font-300-15">
              1. The right to be forgotten (or the right of erasure)
            </p>
            <p className="font-300-15">
              2. The right to know how we are processing your personal
              information
            </p>
            <p className="font-300-15">
              3. The right to access your personal information
            </p>
            <p className="font-300-15">4. The right to rectification</p>
            <p className="font-300-15">5. The right to withdraw consent</p>
            <p className="font-300-15">
              6. The right to object to processing your personal information
            </p>
            <p className="font-300-15">
              7. The right to object to certain types of data processing, e.g.:
              direct marketing; the processing of data in the public interest;
              the exercising of official authority invested in you; processing
              of you or a third party’s legitimate interest; data processing
              based on your own beliefs and situations.
            </p>
            <p className="font-300-15">
              To exercise any of these rights, contact{" "}
              <a href="mailto:privacy@fan1.us" className="text-light-purple text-decoration-none">
                privacy@fan1.us
              </a>
            </p>
            <p>
              <span className="spanterms">
                What information does Fan1 collect?
              </span>
              <br />
              Fan1 may collect, process, and store personal information about
              you, including, without limitation:
            </p>
            <p>
              <p className="font-300-15">
                • your name and contact details, including username, email
                address, and telephone number;{" "}
              </p>
              <p className="font-300-15">
                • information about your location, including IP address, billing
                address, and time zone;{" "}
              </p>
              <p className="font-300-15">
                • details you have provided in a public-facing profile or
                through messages sent;
              </p>
              <p className="font-300-15">
                • your purchase history and payment methods;
              </p>
              <p className="font-300-15">
                • information about your use of our site.
              </p>
            </p>
            <p className="font-300-15">
              <span className="spanterms">
                Particularly Sensitive Personal information
              </span>
              <br />
              Fan1 does not process special categories of personal information.
            </p>
            <p className="font-300-15">
              <span className="spanterms">
                How is your personal information collected?
              </span>
              <br />
              Fan1 may collect the categories of information listed above in a
              variety of ways. For example, data might be collected through your
              use of our site or mobile applications; via submission of contact
              forms; from correspondence or conversation with you; through your
              authorized agent; through connected social media accounts; or
              through referral links or ads on other sites.
            </p>
            <p className="font-300-15">
              Data will be stored in a range of different places, including in
              Fan1’s application databases hosted by third-parties and in other
              IT systems (including Fan1’s email, customer relationship
              management, and marketing automation systems).
            </p>

            <p className="font-300-15">
              <span className="spanterms">Children’s Online Privacy</span>
              <br />
              Fan1 does not collect personal information from users under the
              age of 13. Users must be a at least 13 years of age (or older if
              their jurisdiction requires) to use the site and this is stated in
              terms of service. Users purchasing a membership must check a box
              stating they are at least 18 years of age or have parent’s or
              guardian’s permission. Fan1 complies with COPPA, the Children’s
              Online Privacy Protection Act in the U.S.
            </p>

            <p className="font-300-15">
              <span className="spanterms">
                Why does Fan1 process personal information?
              </span>
              <br />
              Fan1 needs to process all the categories of data in the list above
              primarily to provide services to you. In some cases, Fan1 needs to
              process data to comply with its legal obligations. In other cases,
              Fan1 has a legitimate interest in processing personal information
              before, during and after the end of our relationship.
            </p>

            <p className="font-300-15">
              We will not use your personal information for purposes other than
              that for which it was collected, unless required by law or we
              reasonably consider that this is required, and the reason is
              compatible with the original purpose. If we need to use it for an
              unrelated purpose, we will notify you and explain the legal basis
              which allows us to do so. Please be aware that we may process your
              personal information without your knowledge or consent, in
              compliance with the above, where it is required or permitted by
              law.
            </p>

            <p className="font-300-15">
              The legal basis on which we will process your personal information
              is to carry out our obligations under our services agreement.
            </p>

            <p className="font-300-15">
              <span className="spanterms">Who has access to data?</span>
              <br />
              Your information may be shared internally, including with
              employees of Fan1. We limit sharing your personal information to
              only those of our employees on a need-to-know basis.
            </p>

            <p className="font-300-15">
              Fan1 may share personal information in the context of business
              reorganization or group restructuring exercise, for system
              maintenance support and hosting of data. This may involve
              transferring your data to another country. Where required by
              applicable law, we will not share your personal information
              outside of its country of location with third parties unless there
              is an appropriate data transfer mechanism in place.
            </p>

            <p className="font-300-15">
              Fan1 may also share your personal information with third parties
              in the context of a sale of some or all of its business. In those
              circumstances the personal information will be subject to
              confidentiality arrangements.
            </p>

            <p className="font-300-15">
              Fan1 may also share your personal information with third parties
              that process information on its behalf, such as Amazon Web
              Services, Google, Salesforce, Okta and Stripe.All third-party
              service providers are required to take appropriate security
              measures to protect your personal information in line with our
              policies.  We will not allow our third-party service providers to
              use your personal information for their own purposes.We only
              permit them to process your personal information for specified
              purposes and in accordance with our instructions.
            </p>

            <p className="font-300-15">
              <span className="spanterms">
                How does Fan1 protect your personal information?
              </span>
              <br />
              Fan1 takes the security of your personal information seriously.
              Fan1 has internal policies and controls in place so that your
              personal information is not lost, accidentally destroyed, misused,
              or disclosed, and is not accessed except by its employees in the
              performance of their duties.
            </p>

            <p className="font-300-15">
              In addition, we will limit access to your personal information to
              those employees, agents, contractors and other third parties who
              have a business need to know. Where Fan1 engages third parties to
              process personal information on its behalf, these third parties do
              so on the basis of written instructions, are under a duty of
              confidentiality, and are obliged to implement appropriate
              technical and organizational measures to facilitate the security
              of data.
            </p>
            <p className="font-300-15">
              <span className="spanterms">
                For how long does Fan1 keep data?
              </span>
              <br />
              We will only retain your personal information for as long as is
              necessary to fulfil the purposes we collected it for, including
              for the purposes of satisfying any legal, accounting, or reporting
              requirements. Fan1 will hold your personal information at least
              for the duration of your use of our services , however, to
              determine the specific appropriate retention period for personal
              information, we will consider the amount, nature and sensitivity
              of the personal information, the potential risk of harm from
              unauthorized use or disclosure of your personal information, the
              purpose for which we process your personal information, whether we
              can achieve those purposes through other means, and the applicable
              legal requirements of your jurisdiction.
            </p>

            <p className="font-300-15">
              <span className="spanterms">Legal Basis</span>
              <br />
              Our legal basis for processing your personal information will
              depend on the personal information concerned and the specific
              context in which it is collected. However, we will normally
              collect or process personal information from you only where:
            </p>

            <p>
              <p className="font-300-15">
                • we have a legal obligation to do so;
              </p>
              <p className="font-300-15">
                • the personal information is required for performance of our
                obligations;
              </p>
              <p className="font-300-15">
                • the personal information is needed for legitimate interests;
              </p>
            </p>
            <p className="font-300-15">
              Some of the personal information we collect may be considered
              sensitive information, or special categories of data under
              applicable data protection laws. If we collect sensitive data, we
              will ensure that we have a legitimate reason for processing
              sensitive data.
            </p>

            <p className="font-300-15">
              <span className="spanterms">Transfers</span>
              <br />
              Sharing personal information with a third-party service provider
              may mean your data is transferred to the US. We endeavour to
              maintain a similar degree of protection as that provided in the EU
              by implementing at least one of the following safeguards:
            </p>
            <p>
              <p className="font-300-15">
                • We will transfer your personal information to countries for
                which there is an adequacy decision. This means that they have
                been deemed by the EU or the UK to provide an adequate level of
                protection for personal information.
              </p>
              <p className="font-300-15">
                • Where we use certain service providers, we may use specific
                contracts which give personal information the same protection it
                has under applicable data protection laws.
              </p>
            </p>

            <p className="font-300-15">
              <span className="spanterms">Automated decision-making</span>
              <br />
              Automated decision-making takes place when an electronic system
              uses personal information to make a decision without human
              intervention, and this type of processing is only permissible in
              specified circumstances.
            </p>

            <p className="font-300-15">
              Within Fan1, decisions are not based solely on automated
              decision-making.
            </p>

            <p className="font-300-15">
              If you believe that Fan1 has not complied with your data
              protection rights, you can complain to, in the case of the US, the
              Attorney General in your state. If you reside outside of the U.S.,
              you can complain to the Data Protection Authority in your country.
            </p>

            <p className="font-300-15">
              <span className="spanterms">Changes to this privacy notice</span>
              <br />
              We reserve the right to update our privacy policies at any time,
              and we will revise this written policy when we make updates
              applicable to you. We may also notify you from time to time in
              other ways about the processing of your personal information.
            </p>
            <p className="font-300-15">
              <span className="spanterms">Contact Information</span>
              <br />
              If you have any questions or concerns about the data we hold or
              would like to exercise any of your rights under applicable law,
              please email us at{" "}
              <a href="mailto:privacy@fan1.us" className="text-light-purple text-decoration-none">
                privacy@fan1.us
              </a>
            </p>

            <p className="font-300-15"> Last updated April 15, 2025</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPage;
